import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { InkButton } from '../components/InkButton';
import { InkedTitle } from '../components/InkedTitle';
import { useBooking } from '../context/BookingContext';

export function NotFoundPage() {
  const { t } = useTranslation();
  const { openBooking } = useBooking();

  return (
    <section className="relative min-h-[100svh] flex flex-col justify-end px-6 pb-16 pt-32 md:px-10 md:pb-24 md:pt-44 overflow-hidden">
      <motion.span
        aria-hidden
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 0.04, y: 0 }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="pointer-events-none absolute -top-20 -left-6 md:-left-10 font-display tracking-display text-[clamp(20rem,55vw,50rem)] leading-none text-ink-paper select-none"
      >
        404
      </motion.span>

      <div className="mx-auto w-full max-w-[1800px] relative">
        <p className="text-sm font-display lowercase tracking-tight text-ink-muted">
          Error · 404
        </p>
        <InkedTitle
          as="h1"
          immediate
          delay={0.2}
          className="mt-6 font-display tracking-display leading-[0.85] text-[clamp(3rem,10vw,10rem)] lowercase"
        >
          {t('notFound.title')}
        </InkedTitle>
        <p className="mt-8 max-w-md text-lg md:text-xl text-ink-paper/75">
          {t('notFound.subtitle')}
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-6">
          <InkButton as="link" to="/" size="lg">
            {t('notFound.cta')}
          </InkButton>
          <InkButton as="button" size="md" variant="link" onClick={() => openBooking()}>
            {t('nav.book')}
          </InkButton>
        </div>
      </div>
    </section>
  );
}
